import { createApi } from "@reduxjs/toolkit/query/react";
import { API_END_POINTS } from './apiEndpoints';
import { DynamicBaseQueryHeader } from './DynamicBaseQueryHeader';

const appendParam = (params: URLSearchParams, key: string, value: any) => {
    if (value === undefined || value === null || value === '') return;
    params.append(key, String(value));
};

export const DraftApi = createApi({
    reducerPath: 'DraftApi',
    baseQuery: DynamicBaseQueryHeader("Draft"),
    endpoints: (builder) => ({
        getAllUserDraft: builder.query({
            query: (args) => {
                const {
                    pageSize, pageNumber, sortBy, sortOrder, searchStr, filterByStatus,
                    filterByCcRequest = 0,
                    filterByUserName, filterByEmail, filterByOrgName,
                    filterByDraftId, filterBySsId, filterByDivisionId,
                    filterByDepartmentId, filterByLocationId, filterByPhone,
                    requestedFrom, requestedTo, modifiedFrom, modifiedTo, approvedFrom, approvedTo,
                } = args || {};
                const params = new URLSearchParams();
                appendParam(params, 'pageSize', pageSize);
                appendParam(params, 'pageNumber', pageNumber);
                appendParam(params, 'sortBy', sortBy);
                appendParam(params, 'sortOrder', sortOrder);
                appendParam(params, 'searchStr', searchStr ?? '');
                appendParam(params, 'filterByStatus', filterByStatus);
                appendParam(params, 'filterByCcRequest', filterByCcRequest || 0);
                appendParam(params, 'filterByUserName', filterByUserName);
                appendParam(params, 'filterByEmail', filterByEmail);
                appendParam(params, 'filterByOrgName', filterByOrgName);
                appendParam(params, 'filterByDraftId', filterByDraftId);
                appendParam(params, 'filterBySsId', filterBySsId);
                appendParam(params, 'filterByDivisionId', filterByDivisionId);
                appendParam(params, 'filterByDepartmentId', filterByDepartmentId);
                appendParam(params, 'filterByLocationId', filterByLocationId);
                appendParam(params, 'filterByPhone', filterByPhone);
                appendParam(params, 'requestedFrom', requestedFrom);
                appendParam(params, 'requestedTo', requestedTo);
                appendParam(params, 'modifiedFrom', modifiedFrom);
                appendParam(params, 'modifiedTo', modifiedTo);
                appendParam(params, 'approvedFrom', approvedFrom);
                appendParam(params, 'approvedTo', approvedTo);
                return {
                    url: `${API_END_POINTS.getAllUserDraft}?${params.toString()}`,
                    method: "GET",
                }
            },
        }),
        activateUserDraft: builder.mutation({
            query: (body) => ({
                url: API_END_POINTS.activateUserDraft,
                method: "PUT",
                body,
            }),
        }),
        updateUserDraft: builder.mutation({
            query: (body) => ({
                url: API_END_POINTS.updateUserDraft,
                method: "PUT",
                body,
            }),
        }),
        getUserDraftById: builder.query({
            query: (id: number) => ({
                url: `${API_END_POINTS.getUserDraftById}?id=${id}`,
                method: "GET",
            }),
        }),
        getAllPendingRequestedUser: builder.query({
            query: () => ({
                url: `${API_END_POINTS.getAllPendingRequestedUser}`,
                method: "GET",
            }),
        }),
    }),
})

export const {
    useGetAllUserDraftQuery,
    useActivateUserDraftMutation,
    useUpdateUserDraftMutation,
    useGetUserDraftByIdQuery,
    useLazyGetUserDraftByIdQuery,
    useGetAllPendingRequestedUserQuery
} = DraftApi
